import { companies } from "@/mocks/partes";

export default function CompaniesTable() {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-semibold text-foreground-900">Empresas e Contratantes ({companies.length})</h3>
        <button className="px-3 py-1.5 text-xs font-medium text-primary-700 bg-primary-50 rounded-lg hover:bg-primary-100 transition-colors whitespace-nowrap">
          <i className="ri-add-line w-3.5 h-3.5 inline-flex items-center justify-center mr-1" />
          Nova empresa
        </button>
      </div>
      <div className="overflow-x-auto bg-white rounded-xl border border-background-200/70">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-background-200 bg-background-50/50">
              <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Razão social</th>
              <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider hidden md:table-cell">Nome fantasia</th>
              <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider hidden lg:table-cell">CNPJ</th>
              <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Tipo</th>
              <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider hidden xl:table-cell">Contato</th>
              <th className="text-center px-4 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Projetos</th>
              <th className="text-center px-4 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider hidden lg:table-cell">Obrigações</th>
              <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Status</th>
            </tr>
          </thead>
          <tbody>
            {companies.map((comp) => (
              <tr key={comp.id} className="border-b border-background-100 hover:bg-background-50/50 transition-colors">
                <td className="px-4 py-3">
                  <p className="text-sm font-medium text-foreground-900">{comp.companyName}</p>
                </td>
                <td className="px-4 py-3 text-xs text-foreground-500 hidden md:table-cell">{comp.tradeName}</td>
                <td className="px-4 py-3 text-xs text-foreground-500 hidden lg:table-cell">{comp.cnpj}</td>
                <td className="px-4 py-3">
                  <span className="inline-block px-2 py-0.5 rounded-full text-xs font-medium bg-accent-100 text-accent-700 whitespace-nowrap">{comp.type}</span>
                </td>
                <td className="px-4 py-3 hidden xl:table-cell">
                  <p className="text-xs text-foreground-700">{comp.contactPerson}</p>
                  <p className="text-xs text-foreground-400">{comp.email}</p>
                </td>
                <td className="px-4 py-3 text-center">
                  <span className="text-xs font-semibold text-primary-600">{comp.linkedProjects}</span>
                </td>
                <td className="px-4 py-3 text-center hidden lg:table-cell">
                  <span className="text-xs font-semibold text-warning-600">{comp.environmentalObligations}</span>
                </td>
                <td className="px-4 py-3">
                  <span className="inline-block px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap bg-primary-100 text-primary-700">{comp.status}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}